import React, { useState, useRef, useEffect } from "react";

import api from "../../helpers/api.js";

import * as Material from "@mui/material";

import { useChallenge } from "../../contexts/ChallengeContext";

import MainButton from "../SmallComponents/MainButton";

import LandscapeIcon from "@mui/icons-material/Landscape";
import SettingsIcon from "@mui/icons-material/Settings";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import { ReactComponent as SilverMedal } from "../../assets/custom-icons/silver-medal.svg";
import { ReactComponent as GoldenMedal } from "../../assets/custom-icons/gold-medal.svg";
import { ReactComponent as BronzeMedal } from "../../assets/custom-icons/bronze-medal.svg";
import { ReactComponent as PostCreation } from "../../assets/draws/product-creation.svg";

import "./styles.css";

const Feed = ({
  fitContentHeight = false,
  filterByUser = {},
  containerProps = {},
}) => {
  const [loadingFeed, setLoadingFeed] = useState(true);

  const [posts, setPosts] = useState([]);

  const { loading, currentChallenge, handleOpenChallengesSelect } =
    useChallenge();

  const isInSpecificUserMode = !!filterByUser?.id;
  const firstName = isInSpecificUserMode
    ? filterByUser.username?.split(" ")[0]
    : null;

  useEffect(() => {
    if (loadingFeed) loadFeed();
  }, [loadingFeed, filterByUser]);

  useEffect(() => {
    setLoadingFeed(true);
  }, [currentChallenge]);

  async function loadFeed() {
    try {
      const searchString = isInSpecificUserMode
        ? "?user_id=" + filterByUser.id
        : "?challenge_id=" + currentChallenge?.challenge_id;

      const { data } = await api.get("/challenge/feed" + searchString);

      setPosts([...data]);
    } catch (e) {
      window.setSnackbar("Houve um erro ao carregar o feed");
    }
    setLoadingFeed(false);
  }

  const Post = ({ info }) => {
    const { publisher_data, post_data } = info;
    return (
      <div className="post mb-4">
        <div className="post-header">
          <img src={publisher_data.avatar} className="avatar" />
          <a
            className="anchor"
            onClick={() => window.openUserDetails(publisher_data.id)}
          >
            <span>{publisher_data.name}</span>
          </a>
        </div>
        <div className="post-content mt-1">
          <span>{post_data.text}</span>
          {post_data.photo && (
            <img src={post_data.photo} className="post-photo mt-1" />
          )}
        </div>
      </div>
    );
  };

  const CommunityInfo = () => {
    return (
      <div className="community-info mb-2">
        {!loading && (
          <>
            <Material.Tooltip title="Alterar desafio" arrow>
              <a
                className="select-challenge"
                onClick={handleOpenChallengesSelect}
              >
                {currentChallenge?.banner ? (
                  <img
                    src={currentChallenge?.banner}
                    className="challenge-banner"
                  />
                ) : (
                  <LandscapeIcon className="challenge-banner" />
                )}
                <div style={{ flexGrow: 1 }}>
                  <small>Comunidade</small>

                  <h5>{currentChallenge?.name}</h5>
                </div>
                <ArrowDropDownIcon />
              </a>
            </Material.Tooltip>
          </>
        )}
      </div>
    );
  };

  const Podium = () => {
    const [loadingPodium, setLoadingPodium] = useState(true);

    const [podium, setPodium] = useState([]);

    useEffect(() => {
      if (loadingPodium) loadPodium();
    }, [loadingPodium]);

    useEffect(() => {
      setLoadingPodium(true);
    }, [currentChallenge]);

    async function loadPodium() {
      try {
        const result = await api.get(
          "/challenge/podium?challenge_id=" + currentChallenge?.challenge_id
        );
        setPodium([...result.data]);
      } catch (e) {
        window.setSnackbar("Houve um erro ao carregar o feed");
      }
      setLoadingPodium(false);
    }

    const Position = ({ points, position, username, email }) => {
      const medal = {
        1: <GoldenMedal width={32} height={32} />,
        2: <SilverMedal width={32} height={32} />,
        3: <BronzeMedal width={32} height={32} />,
      }[position];

      return (
        <div className={"podium-position position-" + position}>
          <div>{medal}</div>
          <div className="podium-member-info">
            <div className="position-title">
              <Material.Tooltip title={username} arrow>
                <span className="username">{username || email}</span>
              </Material.Tooltip>
              <small className="points">{points || 0} pontos</small>
            </div>
          </div>
        </div>
      );
    };

    if (loadingPodium)
      return (
        <>
          <Material.Skeleton height={40} className="mt-1" />
          <Material.Skeleton height={40} className="mt-1" />
          <Material.Skeleton height={40} className="mt-1" />
        </>
      );

    return (
      <div className="podium mt-4 mb-2">
        {podium[0] && (
          <Position
            points={podium[0].points}
            position={1}
            username={podium[0].username}
          />
        )}
        {podium[1] && (
          <Position
            points={podium[1].points}
            position={2}
            username={podium[1].username}
          />
        )}
        {podium[2] && (
          <Position
            points={podium[2].points}
            position={3}
            username={podium[2].username}
          />
        )}
      </div>
    );
  };

  const Progress = () => {
    if (!currentChallenge?.started_at) return;

    const timeDifference = new Date() - new Date(currentChallenge?.started_at);
    const elapsedDays = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    const progress = (elapsedDays / currentChallenge?.duration) * 100;

    return (
      <div className="progress mb-3 mt-2">
        <div className="progress-area">
          <div
            className="progress-bar"
            style={{ width: `${progress > 100 ? 100 : progress}%` }}
          ></div>
        </div>
        <div className="progress-info">
          <span className="progress-days">Progresso</span>
          <span className="progress-days">
            {elapsedDays}/{currentChallenge?.duration} dias
          </span>
        </div>
      </div>
    );
  };

  const NoPostsFound = () => {
    return (
      <div className="no-posts-found mt-3" {...containerProps}>
        <PostCreation className="no-posts-banner" />
        <h4 className="mb-1 mt-1">
          {isInSpecificUserMode
            ? firstName + " ainda não postou em uma comunidade"
            : "Nenhum post foi publicado nessa comunidade ainda"}
        </h4>
        <span>
          Compartilhe o link de convite com sua audiência e os incentive a
          interagir na sua comunidade
        </span>
      </div>
    );
  };

  const LoadingComponents = () => {
    return (
      <div className="loading-feed-container">
        <Material.Skeleton height={50} />
        <Material.Skeleton height={50} />
        <Material.Skeleton height={50} />

        <Material.Skeleton height={80} className="mt-2" />

        <Material.Skeleton height={300} className="mt-2" />
      </div>
    );
  };

  return (
    <div
      className={"feed-area px-1 " + (fitContentHeight && "fluid-feed-height")}
    >
      <div className="feed-header py-1 px-1">
        {isInSpecificUserMode ? (
          <h4 className="community-header-title">Atividades: {firstName}</h4>
        ) : (
          <>
            <h4 className="community-header-title">Atividades</h4>

            <MainButton
              onClick={() => window.navigate("/communities")}
              label="Configurar com."
              color="white"
              endIcon={<SettingsIcon />}
              shadow={false}
            />
          </>
        )}
      </div>
      <div className="feed-container pt-3">
        {loading || loadingFeed ? (
          <LoadingComponents />
        ) : (
          <>
            {!isInSpecificUserMode && (
              <div className="pb-2">
                <CommunityInfo />
                <Podium />
                <Progress />
              </div>
            )}
            {posts.length > 0 ? (
              posts.map((post, i) => <Post key={i} info={post} />)
            ) : (
              <NoPostsFound />
            )}
          </>
        )}

        <div style={{ height: "80px" }}></div>
      </div>
    </div>
  );
};

export default Feed;
